import { State } from '../reducers'

export const getCounter = (state: State) => state.counter
